import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { CHECKOUT_URL } from '../data/content';
type CTAButtonProps = {
  label: string;
  note?: string;
  size?: 'md' | 'lg';
  id?: string;
};
export function CTAButton({
  label,
  note,
  size = 'md',
  id
}: CTAButtonProps) {
  return <div className="w-full flex flex-col items-center" id={id} data-id="element-25" data-mp="2fzl9pcll48wv">
      <a href={CHECKOUT_URL} className={`group w-full max-w-xl inline-flex items-center justify-center gap-2 rounded-2xl bg-brandred text-white font-extrabold uppercase tracking-wide text-center shadow-lg shadow-brandred/30 animate-pulseGlow transition-colors hover:bg-brandred-dark focus:outline-none focus-visible:ring-4 focus-visible:ring-brandred/40 ${size === 'lg' ? 'px-5 py-5 text-base sm:text-lg' : 'px-5 py-4 text-sm sm:text-base'}`} data-id="element-26" data-mp="2fya3z78kwr34">
        <span className="leading-tight" data-id="element-27" data-mp="3cnrm4lor05lp">{label}</span>
        <ArrowRightIcon className="w-5 h-5 shrink-0 transition-transform group-hover:translate-x-1" data-id="element-28" data-mp="38pabhs64cczj" />
      </a>
      {note ? <p className="mt-3 text-xs sm:text-sm text-navy/60 text-center max-w-md" data-id="element-29" data-mp="19apq4lckbwb0">
          {note}
        </p> : null}
    </div>;
}